import { plpLscacheGet, plpLscacheRemove, plpLscacheSet } from './plpLscache';

export const PLP_RESTORE_KEY_PREFIX = 'plp_restore_';

export interface PlpRestoreState {
  scrollTop: number;
  pageCount: number;
  /** Mobile: anchor restore to this product row (preferred over scrollTop). */
  restoreDesignId?: number;
}

export function getPlpRestoreKey(pathname: string): string {
  return `${PLP_RESTORE_KEY_PREFIX}${pathname}`;
}

export function savePlpRestore(pathname: string, state: PlpRestoreState): void {
  plpLscacheSet(getPlpRestoreKey(pathname), state);
}

export function readPlpRestore(pathname: string): PlpRestoreState | null {
  const parsed = plpLscacheGet<PlpRestoreState>(getPlpRestoreKey(pathname));
  if (!parsed) return null;
  if (typeof parsed.scrollTop !== 'number' || typeof parsed.pageCount !== 'number') return null;
  if (parsed.restoreDesignId != null && typeof parsed.restoreDesignId !== 'number') return null;
  return parsed;
}

export function clearPlpRestore(pathname: string): void {
  plpLscacheRemove(getPlpRestoreKey(pathname));
}
